import React from 'react';
import { graphql } from 'gatsby';
import Layout from '@layouts/default-layout';
import SEO from '@components/seo';
import renderModule from '@components/module';
import generateId from '@helpers/generate-id';
import { defaultTheme } from '@styles/theme.styled';
import { MainPageInterface, Container } from '@pages/index';

const pageIdGenerator = generateId();

interface PageProps {
  data: MainPageInterface;
}

const Page = ({ data }: PageProps): JSX.Element => {
  const {
    allPrismicPage,
    prismicGeneralConfig: {
      data: { favicon },
    },
  }: MainPageInterface = data;

  const {
    page_title,
    meta_description,
    meta_image,
    meta_description_tag,
    meta_title_tag,
    meta_image_tag,
    body,
  } = allPrismicPage.nodes[0].data;

  const pageHero = body.find(
    (item: {
      slice_type: string;
      primary?: { background_color?: keyof typeof defaultTheme.backgroundColors };
    }) => item.slice_type === 'page_hero'
  ) as { primary?: { background_color?: keyof typeof defaultTheme.backgroundColors } } | undefined;

  return (
    <Layout heroBgColor={pageHero?.primary?.background_color || undefined}>
      <SEO
        title={meta_title_tag || page_title.text}
        description={meta_description_tag || meta_description.text}
        image={meta_image_tag || meta_image}
        faviconHref={favicon?.url || ''}
      />
      <Container>
        {allPrismicPage.nodes[0].data.body.map(
          (module) =>
            module && (
              <React.Fragment key={pageIdGenerator.next().value}>
                {renderModule(module, allPrismicPage.nodes[0].last_publication_date)}
              </React.Fragment>
            )
        )}
      </Container>
    </Layout>
  );
};

export default Page;

export const query = graphql`
  query PageQuery($uid: String!) {
    prismicGeneralConfig {
      ...GeneralConfigFragment
    }
    allPrismicPage(filter: { uid: { eq: $uid, ne: "home" } }) {
      nodes {
        ...PageFragment
      }
    }
  }
`;
